import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import arJSON from "./locals/ar.json";
import enJSON from "./locals/en.json";
import frJSON from "./locals/fr.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { ...enJSON },
    fr: { ...frJSON },
    ar: { ...arJSON },
  },
  interpolation: {
    escapeValue: false,
  },
  lng: "en",
});

export default i18n;
